module.exports = __webpack_public_path__ + "media/images/lb/173-264fcca9ddcfe97a85b21e1adf56e325.svg";